import { render, staticRenderFns } from "./FullTextDialog.vue?vue&type=template&id=a6d65628"
import script from "./FullTextDialog.vue?vue&type=script&lang=js"
export * from "./FullTextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports